import cn from "classnames";
import { Contract, formatUnits } from "ethers";
import React, { useEffect, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CloseSvg from "../../components/svgComponents/CloseSvg";
import {
  approveUSDTForXBRNODE,
  buyNode,
  registerNode,
} from "../../uniswap/utils";
import {
  ERC20_ABI,
  USDT_TOKEN,
  proceedMintAndClaim,
  storeUSDTTransactionDetails,
} from "../../web3Utils";
import { BootstrapDialog } from "../newBuyNode/components/NodeModal";
import { useContextProvider } from '../../context';
import { getEthersSigner } from '../../utils/wagmi.utils';

const ConfirmNodeComponent = ({ closeModal, isOpen, quantity, address }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [approve, setApprove] = useState(false);
  const [transactions, setTransactions] = useState({});
  const validQuantity =
    isNaN(quantity) || quantity === undefined ? 0 : quantity;
  const [isProceeding, setIsProceeding] = useState(false);
  const [usdtBalance, setUsdtBalance] = useState("0.00");
	const {walletAddress, jsonRpcProvider}= useContextProvider();

  const handleProceed = async () => {
    setIsProceeding(true);
    try {
			const signer = await getEthersSigner()
      const result = await buyNode(validQuantity, address, signer);
      if (result) {
        await handleProceedButton(result);
        const tokenIds = await result.logs
          .map((log) => parseInt(log.topics[3], 16))
          .filter((id) => !isNaN(id) && id < Number.MAX_SAFE_INTEGER);
        await registerNode(tokenIds, walletAddress);
        setIsProceeding(false);
        navigate("/node");
      }
      setIsProceeding(false);
      toast.error("Error please try again:", { duration: 1000 });
    } catch (error) {
      setIsProceeding(false);
      console.error("Error in handleProceed:", error);
      toast.error(error.toString(), { duration: 2000 });
    }
  };

  const fetchbalance = async (walletAddress,jsonRpcProvider) => {
    try {
			if (!walletAddress ||!jsonRpcProvider) return;
      const usdtContract = new Contract(USDT_TOKEN.address, ERC20_ABI, jsonRpcProvider);
      const usdtBalance = formatUnits(await usdtContract.balanceOf(walletAddress), 6);

      setUsdtBalance(usdtBalance);
    } catch (error) {
      console.error("Error fetching balances:", error);
    }
  };

  useEffect(() => {
    fetchbalance(walletAddress,jsonRpcProvider);
  }, [walletAddress, jsonRpcProvider]);

  const handleApprove = async () => {
    try {
      const totalCost =
        validQuantity * Number(process.env.REACT_APP_NODE_PRICE);
      if (Number(usdtBalance) < totalCost) {
        toast.error("Insufficient balance", { duration: 2000 });
        setIsLoading(false);
        return;
      }
      const amount = validQuantity * Number(process.env.REACT_APP_NODE_PRICE);
      if (!approve && !isLoading) {
				const signer = await getEthersSigner()
        setIsLoading(true);
        const approval = await approveUSDTForXBRNODE(amount, signer, jsonRpcProvider);
        setIsLoading(false);
        if (approval) {
          const transactionDetails = {
            fromAddress: walletAddress,
            toAddress: process.env.REACT_APP_CONTRACT_ADDRESS,
            txHash: approval,
            nodesQuantity: validQuantity,
            totalAmount: amount,
            referralWalletAddres: address,
            amountToOwner: amount * 0.8,
            amountToReferralWallet: amount * 0.2,
          };
          const result = await storeUSDTTransactionDetails(transactionDetails);
          if (result) {
            setTransactions(transactionDetails);
            setApprove(true);
          }
        }
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Error please try again:", { duration: 1000 });
      console.error("Error handleApprove:", error);
    }
  };
  const handleProceedButton = async (result) => {
    try {
      const transactionHash = transactions.txHash;
      const tokenIds = result.logs
        .map((log) => parseInt(log.topics[3], 16))
        .filter((id) => !isNaN(id) && id < Number.MAX_SAFE_INTEGER);
      await proceedMintAndClaim(
        process.env.REACT_APP_CONTRACT_ADDRESS,
        walletAddress,
        validQuantity,
        transactionHash,
        tokenIds
      );
    } catch (error) {
      setIsLoading(false);
      toast.error("Error please try again:", { duration: 2000 });
      console.error("Error in handleProceed:", error);
    }
  };

  return (
    <BootstrapDialog onClose={closeModal} open={isOpen}>
      <div className="font-inter w-88 bg-white shadow-smallShadow rounded-3xl dark:bg-[#1D1C2D]">
        <div className="w-full flex justify-between items-center md:items-start h-full py-4 px-4 md:py-6 border-b border-lightGrayBlue dark:border-darkSlateBlue">
          <h3 className="font-bold leading-6 text-xl md:text-lg text-black dark:text-white">
            BUY FOUNDER'S NODES
          </h3>
          <button
            type="button"
            onClick={closeModal}
            className="w-[30px] h-[30px] rounded-lg flex items-center justify-center bg-white border border-deepBlue shadow-maxButtonShadow dark:bg-transparent dark:hover:!bg-[#36345F]"
          >
            <CloseSvg />
          </button>
        </div>
        <div
          className={
            "font-inter  w-full flex py-4 px-4 md:py-6 justify-between gap-2 border-b border-lightGrayBlue dark:border-darkSlateBlue"
          }
        >
          <p className="text-semiBlack text-sm  md:text-base leading-[14.4px] md:leading-4 flex items-center gap-2 dark:text-semiWhite">
            Total price
          </p>
          <p className="text-black text-sm  md:text-base leading-6 dark:text-white">
            {validQuantity * Number(process.env.REACT_APP_NODE_PRICE)} USDT
          </p>
        </div>
        <div className="flex gap-2 py-4 px-4 md:py-6">
          <button
            type="button"
            className={cn(
              "w-full bg-deepBlue hover:!bg-[#8C96FF] active:!bg-[#1E31FF] transition-all duration-300 rounded-lg h-12 flex justify-center items-center text-white font-medium text-base leading-6 border border-white shadow-swapButton",
              {
                "cursor-not-allowed pointer-events-none bg-iceBlue !text-lightBlack shadow-none dark:!text-semiWhite dark:!bg-darkButBg dark:border-none":
                  approve,
              }
            )}
            onClick={handleApprove}
            disabled={approve || isLoading}
          >
            {approve ? "Approved" : "Approve"}
          </button>
          <button
            type="button"
            onClick={handleProceed}
            disabled={!approve || isLoading}
            className={cn(
              "w-full bg-deepBlue hover:!bg-[#8C96FF] active:!bg-[#1E31FF] transition-all duration-300 rounded-lg h-12 flex justify-center items-center text-white font-medium text-base leading-6 border border-white shadow-swapButton",
              {
                "cursor-not-allowed  pointer-events-none bg-iceBlue !text-lightBlack shadow-none dark:!text-semiWhite dark:!bg-darkButBg dark:border-none":
                  !approve,
              }
            )}
          >
            Proceed
          </button>
        </div>
      </div>
      <Toaster />
    </BootstrapDialog>
  );
};

export default ConfirmNodeComponent;
